import { useMutation } from "@tanstack/react-query";
import { useClient } from "../context/auth-context";
import { generateMetaData } from "../util";
import { useIpDetails } from "./location-service";
import { fetchServiceJson } from "./service-fetch";

export function useAddToWaitlist({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();

  return useMutation(
    (email) =>
      client("contact/create", {
        data: {
          email,
          contactType: "WAITING_LIST",
          ...generateMetaData(data),
        },
      }),
    {
      ...config,
    },
  );
}

export function useContactFormList({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();

  return useMutation(
    (params) =>
      client("contact/create", {
        data: {
          ...params,
          contactType: "LETS_TALK",
          ...generateMetaData(data),
        },
      }),
    {
      ...config,
    },
  );
}

export async function sendToSlack(message) {
  return fetchServiceJson("webhook/slack", null, {
    method: "POST",
    data: message,
  })
    .catch((e) => {
      console.log("server side token failed", { e });
    });
}
